export default {
  name: 'DraftDeleteConfirmation',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    open: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    onDelete() {
      this.$emit('confirm');
    },
  },
};
